"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // Framework and third-party non-ui
// JSON & Styles
// Third-party components (buttons, icons, etc.)
var SortPopover = function SortPopover(_ref) {
  var columnConfig = _ref.columnConfig,
    handleQueryChange = _ref.handleQueryChange,
    sortField = _ref.sortField,
    sortOrder = _ref.sortOrder;
  var _useState = (0, _react.useState)({
      sortField: sortField,
      sortOrder: sortOrder
    }),
    _useState2 = _slicedToArray(_useState, 2),
    sortOptions = _useState2[0],
    setSortOptions = _useState2[1];
  var _useState3 = (0, _react.useState)([sortField, sortOrder]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedValues = _useState4[0],
    setSelectedValues = _useState4[1];
  (0, _react.useEffect)(function () {
    setSortOptions({
      sortField: sortField,
      sortOrder: sortOrder
    });
  }, [sortField, sortOrder]);

  // The method for setting state with selected DropdownItem was taken from this Calcite Components example.  It could very well be simplified/improved: https://codesandbox.io/s/calcite-components-dropdown-multiselect-revert-ykjul
  var toggleSort = function toggleSort(e) {
    var selectedItems = e.target.selectedItems.map(function (el) {
      return el.dataset.value;
    });
    setSelectedValues(selectedItems);
    var options = e.target.selectedItems.reduce(function (acc, el) {
      acc[el.parentElement.dataset.value] = el.dataset.value;
      return acc;
    }, {});
    setSortOptions(options);
    handleQueryChange({
      sortBy: options.sortField,
      sortDirection: options.sortOrder
    });
  };
  var renderDropdownItems = function renderDropdownItems(parameter, fields) {
    return fields.map(function (field) {
      return /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteDropdownItem, {
        key: field,
        active: selectedValues.includes(field) || undefined,
        "data-value": field
      }, formatField(parameter, field));
    });
  };
  var getSortIcon = function getSortIcon(direction) {
    switch (direction) {
      case "asc":
        return "sort-ascending";
      default:
        return "sort-descending";
    }
  };
  var formatField = function formatField(parameter, field) {
    if (parameter === "sortOrder") {
      var isDescending = field === "desc";
      switch (sortOptions.sortField) {
        case "title":
        case "type":
        case "owner":
        case "name":
          return "".concat(isDescending ? "Reverse-" : "", "Alphabetical");
        case "avgRating":
        case "numComments":
        case "numRatings":
        case "numViews":
          return "".concat(isDescending ? "Most to Least" : "Least to Most");
        case "modified":
        case "created":
          return "".concat(isDescending ? "Most" : "Least", " Recent");
        default:
          return "".concat(isDescending ? "Descending" : "Ascending");
      }
    }
    var column = columnConfig.find(function (col) {
      return col.dataKey === field;
    });
    return column ? column.label : field[0].toUpperCase() + field.slice(1);
  };
  return /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteDropdown, {
    placement: "bottom-end",
    onCalciteDropdownSelect: function onCalciteDropdownSelect(event) {
      return toggleSort(event);
    }
  }, /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
    slot: "dropdown-trigger",
    alignment: "center",
    iconStart: getSortIcon(sortOptions.sortOrder),
    appearance: "transparent",
    color: "neutral",
    scale: "m"
  }, formatField("sortField", sortOptions.sortField)), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteDropdownGroup, {
    groupTitle: "Sort by",
    selectionMode: "single",
    "data-value": "sortField"
  }, renderDropdownItems("sortField", columnConfig.filter(function (col) {
    return (col === null || col === void 0 ? void 0 : col.filterable) ? col.filterable : col.dataKey.length;
  }).map(function (col) {
    return col.dataKey;
  }))), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteDropdownGroup, {
    groupTitle: "Sort direction",
    selectionMode: "single",
    "data-value": "sortOrder"
  }, renderDropdownItems("sortOrder", ["asc", "desc"])));
};
var _default = SortPopover;
exports.default = _default;